import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const ClaveDescuentoView = lazy(() => import('../../container/configuracion/claveDescuento/Index'));
const ClaveDescuentoForm = lazy(() => import('../../container/configuracion/claveDescuento/Form'));

const ClaveDescuentoRoute = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
             <Route path= {`${path}/catalogos/clave-descuento/listado`} component = { ClaveDescuentoView } />
             <Route path={`${path}/catalogos/clave-descuento/agregar`} component = { ClaveDescuentoForm } />
             <Route exact path = {`${path}/catalogos/clave-descuento/editar/:id`} component = { ClaveDescuentoForm } />
            </Switch>
  );
};

export default ClaveDescuentoRoute;

